<template>
  <div class="control" :class="['control', {'is-loading': isLoading}]">
    <input style="display:none;" type="text" placeholder="Search for or add a new business"/>
    <input
      autocomplete="off"
      type="text"
      :tabindex="tabIndex"
      v-model="search"
      @input="onChange"
      @blur="onBlur"
      @keydown.enter="onEnter"
      class="input"
      :name="inputFieldName"
      :placeholder="placeHolder"/>
    <div :class="['dropdown', { 'is-active' : isOpen && results.length > 0}]">
      <div class="dropdown-menu" role="menu">
        <div class="dropdown-content is-paddingless">
          <a v-for="(result, i) in results" :key="i" @click.prevent="setResult(result)" href="#" :ref="`${result.id}`" :class="['dropdown-item', 'has-text-left']"
             v-html="result.name"></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'ReviewBusinessSearch',
  props: {
    tabIndex: {
      type: Number,
      required: false,
      default: 1
    },
    inputFieldName: {
      type: String,
      required: false,
      default: 'business'
    },
    placeHolder: {
      type: String,
      required: false,
      default: 'Search for or add a new business'
    }
  },
  data() {
    return {
      isOpen: false,
      isBlur: false,
      results: [],
      items: [],
      search: '',
      isLoading: false,
      isLoaded: false,
      ignoreChange: false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  watch: {
    items(val, oldValue) {
      this.results = val
      this.isLoading = false
    },
    search(val, oldValue) {
      if (this.results && this.results[0] && this.results[0].name === val) {
        window.events.$emit('business-search', this.results[0])
      } else if ((!this.results && val) || (this.results && this.results[0] && this.results[0].name !== val)) {
        window.events.$emit('clear-business-search')
      }
      if (typeof val !== 'undefined' && !this.ignoreChange) {
        if (val.length !== oldValue.length && val.length > 2) {
          this.isLoading = true
          const keyword = encodeURIComponent(val)
          axios.get(`/search/business?name=${keyword}`)
            .then(({data}) => {
              if (val === this.search) {
                this.isLoading = false
                this.items = data
                this.isOpen = true
              }
            })
            .catch((error) => {
              console.log(`error searching for business from keyword string [${val}]`, error.response)
              this.items = []
              this.isLoading = false
              this.isOpen = false
            })
        }
      } else if (val.length === 0) {
        this.items = []
        this.isLoading = false
        this.isOpen = false
      } else {
        this.items = []
        this.isLoading = false
        this.isOpen = false
      }
      this.ignoreChange = false
    },
    results() {
      if (this.results.length > 0 && !this.isLoaded) {
        this.setSearch()
      }
    },
    isBlur() {
      if (this.results.length > 0) {
        this.setSearch()
      }
    }
  },
  methods: {
    onBlur() {
      this.ignoreChange = false
      this.isBlur = true
    },
    setSearch() {
      if (this.isBlur) {
        for (var i = 0; i < this.results.length; i++) {
          if (this.results[i].name.trim().toLowerCase() === this.search.trim().toLowerCase()) {
            this.triggerAutoSelect(this.results[i]);
          } else {
            if (this.results[i].aliases !== null && this.results[i].aliases.length > 0) {
              this.results[i].aliases.forEach((item, index) => {
                if (item.alias.trim().toLowerCase() === this.search.trim().toLowerCase()) {
                  this.triggerAutoSelect(this.results[i])
                }
              })
            }
          }
        }
      }
    },
    triggerAutoSelect(searchedResult) {
      this.$emit('businessSelected', searchedResult)
      this.isLoaded = true
      this.isOpen = true
    },
    onChange() {
      this.$emit("input", this.search)
      this.isOpen = false
      this.isLoaded = false
      this.isBlur = false
    },
    setResult(result) {
      this.ignoreChange = true
      this.$emit('businessSelected', result)
      this.search = result.name.trim()
      this.isOpen = false
      this.isLoading = false
    },
    onEnter() {
      this.ignoreChange = true
      if (this.results.length > 0) {
        this.$emit('businessSelected', this.results[0])
        this.search = this.results[0].name.trim()
      } else {
        this.$emit('businessSelected', {
          id: null,
          name: this.search.trim(),
          slug: null,
          status: null,
          primary_email: null,
          subscription: null,
          accepted_invites_count: 0
        })
      }
      this.isOpen = false
      this.isLoading = false
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false
      }
    }
  }
}
</script>
<style scoped>
.input, textarea {
  background-color: white;
  border-color: #dbdbdb;
  border-radius: 0;
  color: #58595B;
  max-width: 100%;
  width: 100%;
  box-shadow: none;
  font-size: 0.85rem;
}

.input {
  height: 40px;
}

.field {
  margin-bottom: 30px;
}

.title {
  font-size: 1rem;
  color: #58595B;
  margin-bottom: 0.8rem;
}

.button {
  border: 0;
  border-radius: 0;
  background-color: #30AAE1;
  color: #ffffff;
  font-size: 0.85rem;
  height: 40px;
  line-height: 40px;
  padding: 0 4rem;
}

.dropdown {
  display: block;
  width: 100%;
}

.dropdown-trigger {
  text-align: left;
  width: 100%;
}

.button-dropdown {
  text-align: left;
  justify-content: left;
  min-width: 100%;
  color: #8A8C91 !important;
  background-color: #fff !important;
  border-color: #dbdbdb !important;
  min-height: 39px !important;
}

.dropdown-menu {
  border-top: 3px solid #30AAE1;
  width: 100%;
  padding-top: 0 !important;
  border-bottom: 1px solid #e1dfdf;
}

.fa-angle-down {
  font-size: 1.4rem;
}

.fa-angle-down:before {
  right: 0.7em;
}

.fa-angle-down:before {
  border: 1px solid #95979b;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.5em;
  pointer-events: none;
  position: absolute;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: center;
  transform-origin: center;
  width: 0.5em;
  margin-top: -0.375em;
  right: 1.125em;
  top: 50%;
  z-index: 4;
}

a.dropdown-item:hover, a.dropdown-item.first-item {
  background-color: #30AAE1;
  color: #fff;
}

.dropdown-item {
  padding: 10px !important;
  border: 1px solid transparent;
}

.dropdown-content {
  border-radius: 0;
  overflow-y: scroll;
  height: 200px;
}

.is-size-6 {
  font-size: 0.85rem !important;
}

.disabled {
  color: lightgray !important;
}

label.disabled {
  color: lightgray;
}

textarea:disabled {
  background-color: transparent;
  color: lightgray;
}

.control:disabled, .control[readonly], .control:disabled::placeholder, .disabled .control::placeholder {
  background-color: transparent;
  color: lightgray;
}

.button.disabled, .button:disabled {
  color: #ffffff;
  background: lightgray;
  border-color: lightgray;
}

.button:disabled > span.is-size-6 {
  color: lightgray !important;
}

@media screen and (max-width: 767px) {
  #write-a-review {
    padding: 0;
  }

  .write-review {
    padding: 1rem;
    width: 100%;
  }

  .bottom-margin {
    margin-bottom: 40px;
  }

  .button-dropdown {
    border: none;
  }

  .dropdown-trigger {
    border: 1px solid #dbdbdb;
  }
}

*:focus {
  outline: none;
}

.clear {
  clear: both;
}

.required {
  color: red;
}

.isErrorVisible {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/ReviewBusinessSearch.vue